import React from "react";
import { Link } from "react-router-dom";
import { ModalContact } from '../modalContact/modalContact'
import { WrapperChats } from '../wrapperChats/wrapperChats'
import "./footer.scss";
import {useValidTokenFromStorage} from "../../hooks/authHook";

export function FooterHome(props) {
  const validateToken = useValidTokenFromStorage();

  return (
    <footer
      className={`footer_home`}
    >
      <ul>
        <li>
            <ModalContact /> 
        </li>
        <li>
          <Link className="link_footer" to="/ambienteseguro.pdf" target="_blank">
            Decálogo
          </Link>
        </li>
        <li>
          <Link className="link_footer" to="/avisoprivacidad.pdf" target="_blank">
            Aviso de Privacidad
          </Link>
        </li>
        <li>
          <Link className="link_footer" to="/terminosycondiciones.pdf" target="_blank">
            Términos y Condiciones
          </Link>
        </li>
      </ul>
      {validateToken ? <WrapperChats /> : null}
    </footer>
  );
}
